import React from "react";
const LoadingSpinner = (props) => {
  return (
    <>
      {props.isLoading && (
        <div id="globalSpiner" className="overlay overlay-inner outer">
          <div>
            <img src="assets/img/icon/Loading-animation.gif" alt=" " />
            <p>
              Đang tải...
              <br />
              Bạn vui lòng đợi P/S một chút nhé!
            </p>
          </div>
        </div>
      )}
    </>
  );
};
export default LoadingSpinner;
